import { PersonalizedPlanDetailsType } from "@covertree/new-business-forms";

import { formatCurrency } from "@covertree/utils";
import { Box, Chip, Typography } from "@mui/material";

interface MobileDetailsModalHeaderProps {
  personalizedPlans: PersonalizedPlanDetailsType[];
}

export function MobileDetailsModalHeader({
  personalizedPlans,
}: MobileDetailsModalHeaderProps) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "flex-start",
        marginBottom: theme.spacing(4),
      })}>
      {personalizedPlans.map((personalizedPlan) => (
        <Box
          key={personalizedPlan.title}
          sx={(theme) => ({
            position: "relative",
            width: "33%",
            padding: theme.spacing(2),
            paddingTop: theme.spacing(6),
            ...(personalizedPlan.isRecommended && {
              backgroundColor: `${theme.palette.info.main}0D`,
              borderRadius: theme.spacing(1.5, 1.5, 0, 0),
            }),
          })}>
          {personalizedPlan.isRecommended && (
            <Box
              sx={{
                position: "absolute",
                transform: "translate(-50%, 0)",
                top: "8px",
                left: "50%",
                margin: "0 auto",
              }}>
              <Chip
                color="secondary"
                label="Recommended"
                size="small"
                sx={{
                  fontSize: {
                    xs: 11,
                    sm: 13,
                  },
                }}
              />
            </Box>
          )}
          <Typography
            sx={{
              fontSize: {
                xs: 14,
                sm: 16,
              },
            }}>
            {personalizedPlan.title}
          </Typography>
          <Typography
            display="flex"
            alignItems="center"
            flexWrap="wrap"
            sx={{
              fontSize: {
                xs: 16,
                sm: 20,
              },
            }}>
            {formatCurrency(personalizedPlan.monthlyPrice, 2)}
            <Typography
              sx={{
                fontSize: {
                  xs: 14,
                  sm: 16,
                },
              }}>
              /mo
            </Typography>
          </Typography>
          <Typography
            variant="subtitle1"
            fontSize={12}
            display="flex"
            flexWrap="wrap">
            ({formatCurrency(personalizedPlan.yearlyPrice, 2)}
            <Typography fontSize={12}>/year)</Typography>
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
